import { render, staticRenderFns } from "./DivisionCreate.vue?vue&type=template&id=e44644e6&"
import script from "./DivisionCreate.vue?vue&type=script&lang=js&"
export * from "./DivisionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports